/**
 * PlayerWaitingRoom — joiner-side lobby view.
 *
 * Same roster as AdminLobbyView, no QR, no BEGIN button. Subhead
 * reassures the player that the game will start when the host says so.
 */

import { useNavigate } from 'react-router-dom';
import { surfaces, fontStacks } from '@qd/design-tokens';
import { ChalkText } from '../base/ChalkText';
import { ChalkButton } from '../base/ChalkButton';
import { RosterList } from './RosterList';
import { LOBBY_MAX_PLAYERS, usePlayers, useLobbyStore } from '../../stores/lobbyStore';

interface PlayerWaitingRoomProps {
  sessionId: string;
}

export function PlayerWaitingRoom({ sessionId }: PlayerWaitingRoomProps) {
  const players = usePlayers();
  const disconnect = useLobbyStore((s) => s.disconnect);
  const navigate = useNavigate();

  const handleQuit = () => {
    disconnect();
    navigate('/');
  };

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 32,
        textAlign: 'center',
        padding: '24px 16px',
      }}
    >
      <ChalkText size="display" underline>
        You&rsquo;re In
      </ChalkText>
      <p
        style={{
          fontFamily: fontStacks.body,
          fontSize: 17,
          color: surfaces.chalk,
          opacity: 0.78,
          maxWidth: 480,
        }}
      >
        Waiting for the others… The lead tester will start the match when
        the roster is ready.
      </p>

      <RosterList players={players} maxPlayers={LOBBY_MAX_PLAYERS} />

      <span
        style={{
          fontFamily: fontStacks.mono,
          fontSize: 12,
          letterSpacing: '0.22em',
          color: surfaces.chalk,
          opacity: 0.45,
        }}
      >
        SESSION · {sessionId.slice(0, 10)}
      </span>

      <ChalkButton 
        variant="secondary" 
        size="lg" 
        onClick={handleQuit}
        style={{ marginTop: 24, padding: '20px 32px', fontSize: 20 }}
      >
        Quit to Main Page
      </ChalkButton>
    </div>
  );
}
